(() => {
  const addUrl = document.body.dataset.cartAddUrl;
  const cartUrl = document.body.dataset.cartUrl;
  if (!addUrl || !cartUrl) return;

  const setButtonLabel = (button, label) => {
    if (!button) return;
    if (button.matches('input')) button.value = label;
    else button.textContent = label;
  };

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('form[action*="/cart/add"]');
    if (!form) return;

    const submitter = event.submitter;
    if (submitter?.closest('.shopify-payment-button')) return;

    event.preventDefault();
    if (form.dataset.cartSubmitting === 'true') return;

    const button = submitter || form.querySelector('button[type="submit"], input[type="submit"]');
    const originalLabel = button?.matches('input') ? button.value : button?.textContent;
    form.dataset.cartSubmitting = 'true';
    button?.setAttribute('aria-busy', 'true');
    if (button) button.disabled = true;
    button?.classList.add('cart-add-button--loading');

    try {
      const addResponse = await fetch(addUrl, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form)
      });
      const addedItem = await addResponse.json();
      if (!addResponse.ok || addedItem.status) throw new Error(addedItem.description || addedItem.message || 'Ajout impossible');

      const cartResponse = await fetch(cartUrl, { headers: { Accept: 'application/json' } });
      if (!cartResponse.ok) throw new Error('Panier indisponible');
      const cart = await cartResponse.json();

      document.dispatchEvent(new CustomEvent('cart:update', { detail: { resource: cart, sourceId: 'ajax-cart-add' } }));
      setButtonLabel(button, 'Ajouté ✓');
      button?.classList.remove('cart-add-button--loading');
      button?.classList.add('cart-add-button--added');

      const cartLink = document.querySelector('.cart-link');
      cartLink?.classList.add('cart-link--updated');

      window.setTimeout(() => {
        setButtonLabel(button, originalLabel || 'Ajouter au panier');
        button?.classList.remove('cart-add-button--added');
        cartLink?.classList.remove('cart-link--updated');
        button?.removeAttribute('aria-busy');
        if (button) button.disabled = false;
        form.dataset.cartSubmitting = 'false';
      }, 1400);
    } catch (error) {
      setButtonLabel(button, 'Réessayer');
      button?.classList.remove('cart-add-button--loading');
      button?.removeAttribute('aria-busy');
      if (button) button.disabled = false;
      form.dataset.cartSubmitting = 'false';
      window.setTimeout(() => setButtonLabel(button, originalLabel || 'Ajouter au panier'), 1800);
    }
  });
})();
